import { render, staticRenderFns } from "./OrderWorkerUpdateModal.vue?vue&type=template&id=2cb9ab67&scoped=true"
import script from "./OrderWorkerUpdateModal.vue?vue&type=script&lang=ts"
export * from "./OrderWorkerUpdateModal.vue?vue&type=script&lang=ts"
import style0 from "./OrderWorkerUpdateModal.vue?vue&type=style&index=0&id=2cb9ab67&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb9ab67",
  null
  
)

export default component.exports